import React from "react";
import ProductsHero from "../sections/ProductsHero";
import ProductsPart from "../sections/ProductsPart";
import Brends from "../sections/Brands";
import Discount from "../sections/Discount";
import ContactSection from "../sections/ContactSection";

const Products = () => {
  return (
    <div>
      <ProductsHero />
      <ProductsPart />
      <Brends />
      <Discount />
      <ContactSection />
    </div>
  );
};

export default Products;
